// Module
var code = "<p class=\"align-center\"><a href=\"/manage\" class=\"button--isCTALinkWithArrow align-center\">EXPLORE ALL MANAGE YOUR LOANS</a></p> ";
// Exports
export default code;